import AppSettings from '../AppSettings';

export default class FileInfosUtil {
    static getUrl(fileInfo, noCache = false) {
        const blobInfos = AppSettings.getBlobInfos();
        const container = fileInfo.type === 'photo' ? blobInfos.containers.photos : blobInfos.containers.files;
        const timestamp = fileInfo.type === 'photo' ? `?timestamp=${Date.now()}` : '';
        return (!noCache && fileInfo.url) || AppSettings.getBlobUrl(container, `${fileInfo.blobName}${timestamp}`);
    }
}